import { createContext, useState, useEffect } from "react";
import { Box, Image, Heading } from "../components/elements";
import { PulseLoader } from "react-spinners";
import { CLRS } from "../constants/colors";
import "../styles/general.css";
import { LOGO_ICON } from "../utils/image.constants";

export const LoaderContext = createContext();

export const AppPreloader = ({ loading = true }) => {
  return (
    <Box className="mc-spinner">
      <Image src={LOGO_ICON} alt="logo" />
      <Box className="mc-spinner-group">
        <Heading className="primeColor">Loading</Heading>
        <PulseLoader color={CLRS.MEAT_BLACK} loading={loading} size={8} />
      </Box>
    </Box>
  );
};

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    const timeoutId = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <LoaderContext.Provider value={{ loading }}>{loading ? <AppPreloader loading={loading} /> : children}</LoaderContext.Provider>
  );
};
